import { CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import { getAccessToken, getRedirectUrl, getToken, refreshOpenProjectToken, validateUser } from '../../services/openProject.service';
import { RootState } from '../../store/store';
import { setIsRefresh, setUserOpState } from "../../store/userSlice";
import { listenToAuthCodeChanges } from '../../utils/helper';
import './style.scss';


declare global {
    interface Window {
        refreshTokenWorker?: ReturnType<typeof setInterval>;
    }
}
const WayMoreProjectLoginComponent = ({
  handleRerender,
}: {
  handleRerender?: () => void;
}) => {
    const [openProjectLoggedInUser, setOpenProjectLoggedInUser] = useState('');
    const [loader, setLoader] = useState(false);
    const userState = useSelector((state: RootState) => state.user);
    const dispatch = useDispatch();

    useEffect(() => {
        console.log(' [TESTING] REGISTER_MESSAGE_OP');
        if (userState.opState === 'null') {
            dispatch(setUserOpState(uuidv4()));
        }
        userAuthentication();
        // listenToAuthCodeChanges();

        const access_token = localStorage.getItem("openProjectAccessToken");
        if (!access_token) {
            openProjectLoggedInEvent();
        }
    }, []);

    useEffect(() => {
      handleRerender?.();
    }, [openProjectLoggedInUser]);


    useEffect(() => {
        console.log('[TESTING] OP STATE', userState.opState);
        if (userState.opState !== 'null') {
            listenToAuthCodeChanges(
                'openProject',
                userState.opState,
                getToken,
                setOpenProjectLoggedInUser,
                refreshOpenProjectToken,
                dispatch
            );
        }
    }, [userState.opState])


    const openProjectLoggedInEvent = async () => {
        try {
            setLoader(true);
            const refresh_token = localStorage.getItem("openProjectRefreshToken");
            if (refresh_token) {
                const { data } = await getAccessToken(refresh_token);
                console.log("[TESTING] GET OP ACCESS TOKEN DATA", data);
                if (data && data.refresh_token && data.access_token) {
                    const isValidUser = await validateUser(data.access_token);
                    if (isValidUser && isValidUser.data && isValidUser.data.id) {
                        setOpenProjectLoggedInUser(isValidUser.data.name);
                        dispatch(setIsRefresh(!userState?.user?.isRefresh));
                        localStorage.setItem('openProjectAccessToken', JSON.stringify(data?.access_token));
                        localStorage.setItem('openProjectRefreshToken', JSON.stringify(data.refresh_token));
                    }
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoader(false);
        }
    };


    const userAuthentication = () => {
        const authToken = localStorage.getItem('authCode');
        if (!authToken) {
            // clearSession();
            // window.location.href = '/notFound';
        }
    };


    const getUrl = () => {
        getRedirectUrl()
            .then((response: any) => {
                if (response.statusCode === 200 && response.data) {
                    console.log('[OP_SEND_STATE]', userState.opState);
                    const url = response.data;
                    const windowFeatures = 'width=800,height=600,resizable=yes,scrollbars=yes';
                    const popup = window.open(url + `&state=${userState.opState}`, 'open project oauth', windowFeatures);
                    console.log("[TESTING] POPUP OPENED")
                    if (!popup) {
                        alert('Popup blocked by browser');
                    }
                }
            })
            .catch((error: any) => { });
    };


    return (
        <span className="button-type">
            <button
                className="btn btn-lg btn-block social-g"
                // PMS Web UI is deprecated — login is disabled.
                // onClick={getUrl}
                disabled
            >
                <img className="openProject-logo" alt="Way more logo" src="./open-project-logo.svg" />
                <span className="openProject-text">{openProjectLoggedInUser ? (
                    <div>Connected as: <br /><strong>{openProjectLoggedInUser}</strong></div>
                ) : (
                    <span>WayMore Project</span>
                )}</span>
                {
                    loader && <CircularProgress style={{ color: 'white' }} size='1.5rem' />
                }
                <img className="openProject-add-icon" alt="Add icon" src="./plus-icon.png" />
                <img className="openProject-way-more-logo" alt="Way more logo" src="./waymore-logo.png" />
            </button>
        </span>
    );
};

export default WayMoreProjectLoginComponent;
